import React from 'react'

import { withSearch } from '@elastic/react-search-ui'
import type { SearchContextState } from '@elastic/react-search-ui/lib/cjs/withSearch'

import Box from 'app/components/base/Box'
import GetMatched from 'app/features/Profile/MatchMeFeature/GetMatched'
import useRefreshPriceByCurrency from 'app/features/Profile/SavedSearchFeature/hooks/useRefreshPriceByCurrency'

import { SearchList } from './components/SearchList'

const selector = ({
  results,
  isLoading,
  wasSearched,
  totalResults,
  resultsPerPage,
  filters,
  searchTerm,
  setSearchTerm,
  error
}: SearchContextState) => ({
  results,
  isLoading,
  wasSearched,
  totalResults,
  resultsPerPage,
  filters,
  searchTerm,
  setSearchTerm,
  error
})

const SearchAppResult = ({
  results = [],
  isLoading,
  wasSearched,
  totalResults,
  resultsPerPage,
  filters,
  searchTerm,
  setSearchTerm,
  error
}) => {
  const isEmpty = (wasSearched && totalResults === 0) || error

  useRefreshPriceByCurrency({ filters, searchTerm, setSearchTerm })

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        minHeight: 500,
        mt: { xs: 1, md: 2 },
        ...(isEmpty && {
          justifyContent: 'center',
          alignItems: 'center'
        })
      }}
    >
      {isEmpty ? (
        <GetMatched />
      ) : (
        <SearchList
          results={results}
          resultsPerPage={resultsPerPage}
          isLoading={isLoading}
        />
      )}
    </Box>
  )
}

export default React.memo(withSearch(selector)(SearchAppResult))
